import React from 'react';
import { Button, ButtonGroup, NavLink } from 'shards-react';
import type { ViewModeButton } from '../../types/common';

interface SwitchViewModeProps<T = string> {
  modes: ViewModeButton[];
  onSwitch: (event: React.MouseEvent<{ id: T }>) => void;
}

const SwitchViewMode = ({ modes, onSwitch }: SwitchViewModeProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ButtonGroup size="sm" className="d-inline-flex mt-3 mb-3 mb-sm-0 mx-auto">
      {modes.map((mode, idx) => {
        return (
          <Button key={'mode-' + idx} id={mode.id} theme="white" tag={NavLink} to="#" active={mode.active} onClick={onSwitch}>
            {mode.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default SwitchViewMode;
